import { themeGet, scrollbar } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  margin-right: ${themeGet('spacing.sm')};
  overflow: hidden auto;
  ${scrollbar({ trackMargin: 'sm' })};
`;
